var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    {
      ref: "container",
      attrs: {
        type: _vm.containerType,
        "better-scroll": _vm.betterScroll,
        "scroll-delay": _vm.scrollDelay
      },
      on: {
        scroll: function(ref) {
          var x = ref.x
          var y = ref.y
          _vm.scrollTop = y
        }
      }
    },
    [
      _c(
        "template",
        { slot: "header" },
        [
          _c(
            "el-form",
            { attrs: { inline: true, size: "mini" } },
            [
              _c(
                "el-form-item",
                { staticClass: "d2-mb-0", attrs: { label: "布局类型" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.containerType,
                        callback: function($$v) {
                          _vm.containerType = $$v
                        },
                        expression: "containerType"
                      }
                    },
                    [
                      _c("el-radio-button", { attrs: { label: "full" } }),
                      _c("el-radio-button", { attrs: { label: "card" } }),
                      _c("el-radio-button", { attrs: { label: "ghost" } })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "d2-mb-0", attrs: { label: "滚动距离" } },
                [
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "130px" },
                      attrs: { value: _vm.scrollTop }
                    },
                    [_c("template", { slot: "append" }, [_vm._v("px")])],
                    2
                  )
                ],
                1
              ),
              !_vm.betterScroll
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "d2-mb-0",
                      attrs: { label: "事件延迟(ms)" }
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "110px" },
                        attrs: { min: 10, max: 2000, step: 100 },
                        model: {
                          value: _vm.scrollDelay,
                          callback: function($$v) {
                            _vm.scrollDelay = $$v
                          },
                          expression: "scrollDelay"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { staticClass: "d2-mb-0" },
                [
                  _vm.scrollTop >= 55
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.$refs.container.scrollToTop }
                        },
                        [_vm._v(" 回到顶部 ")]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("el-alert", {
        staticClass: "d2-mb-10",
        attrs: {
          type: "success",
          title:
            (_vm.betterScroll ? "此示例开启了 BetterScroll " : "") +
            "请向下滚动",
          center: ""
        }
      }),
      _vm._l(10, function(i) {
        return _c("d2-demo-article", {
          key: i,
          style: _vm.articleStyle,
          attrs: { long: "" }
        })
      }),
      _c(
        "el-form",
        {
          attrs: { slot: "footer", inline: true, size: "mini" },
          slot: "footer"
        },
        [
          _c(
            "el-form-item",
            { staticClass: "d2-mb-0" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.$refs.container.scrollBy(0, 30)
                    }
                  }
                },
                [_vm._v("相对滚动 (0, 30) 像素")]
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "d2-mb-0" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.$refs.container.scrollTo(0, 100)
                    }
                  }
                },
                [_vm._v("滚动到 (0, 100) 像素位置")]
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "d2-mb-0" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.$refs.container.scrollTop(100)
                    }
                  }
                },
                [_vm._v("滚动到垂直位置 100")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }